export default {
    AUCTION: 'Auction',
    AUCTION_BIN: 'AuctionBin',
    PURE_BIN: 'PureBin',
    SHOP_ITEM: 'ShopItem'
};
